/* src/app/components/toggle-button-group/toggle-button-group.component.scss */
ion-row {
  justify-content: center;
  margin: 30px 10px 40px;
  padding-bottom: 40px;
}
ion-row.toggle-container > * {
  background: #f5f5f5;
  color: var(--ion-color-main);
  padding: 12px;
}
ion-row.toggle-container *.selected {
  background: var(--ion-color-second);
}
ion-row.toggle-container :first-child {
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
}
ion-row.toggle-container :last-child {
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
}
span {
  display: block;
}
/*# sourceMappingURL=toggle-button-group.component.css.map */
